import { mainFetch } from "../mainFetch";

const SERVICE_URL = '/shipment/report'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });


export default class ReportsApi {

    static async createReport({ data = { market: undefined, shop: undefined, type: undefined, period: undefined, isExpress: undefined, reportIdWb: undefined }, ...params }) {
        return await fetchService({ url: '/create', method: 'POST', data, ...params })
    }

    // static async createReportv2({ data = undefined, ...params }) {
    //     return await fetchService({ url: '/createv2', method: 'POST', data, ...params })
    // }

    static async createReportRealization({ data = { reportId: undefined }, ...params }) {
        return await fetchService({ url: '/createreportrealization', method: 'POST', data, notify: { msg: 'Заказы перенесены' }, ...params })
    }

    // static async createReportRealizationByReturns({ data = { reportId: undefined }, ...params }) {
    //     return await fetchService({ url: '/createrealizationbyreturn', method: 'POST', data, ...params })
    // }

    static async deleteReport({ data = { reportId: undefined }, ...params }) {
        return await fetchService({ url: '/delete', method: 'DELETE', data, ...params })
    }

    static async getReports({ data = { market: undefined, shop: undefined, reportType: undefined, isExpress: undefined, endDate: undefined, status: undefined, limit: undefined, page: undefined }, ...params }) {
        return await fetchService({ url: '/getreports', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async changeReport({ data = { reportId: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/change', method: 'POST', data, ...params })
    }






    // static async changeReportItems({ data = { all: undefined, reportItemIds: undefined, field: undefined, value: undefined }, ...params }) {
    //     return await fetchService({ url: '/changereportitems', method: 'PATCH', data, ...params })
    // }

    static async confirmReport({ data = { reportId: undefined }, ...params }) {
        return await fetchService({ url: '/confirmreport', method: 'PATCH', data, ...params })
    }

    static async getReportItems({ data = { reportIds: 'Array', tab: undefined, providerId: undefined, market: undefined, shop: undefined, isExpress: undefined, search: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined }, ...params }) {
        return await fetchService({ url: '/getreportitems', method: 'POST', data, notify: { success: false }, ...params })
    }




    static async saveReport({ data = { shop: undefined, reportId: undefined, file: undefined }, ...params }) {
        return await fetchService({ url: '/savereport', method: 'POST', data, ...params })
    }

    static async saveReportOzonCommissar({ data = { shop: undefined, reportId: undefined, file: undefined }, ...params }) {
        return await fetchService({ url: '/savereportozoncommissar', method: 'POST', data, ...params })
    }

    static async saveReportPricesWbCommissar({ data = { shop: undefined, reportId: undefined, file: undefined }, ...params }) {
        return await fetchService({ url: '/savereportpriceswbcommissar', method: 'POST', data, ...params })
    }

    // static async saveReportKuper({ data = { shop: undefined, reportId: undefined, file: undefined }, ...params }) {
    //     return await fetchService({ url: '/savereportkuper', method: 'POST', data, ...params })
    // }

    static async saveReportYandex({ data = { shop: undefined, reportId: undefined, file: undefined }, ...params }) {
        return await fetchService({ url: '/savereportyandex', method: 'POST', data, ...params })
    }

    static async loadWbReport({ data = { reportId: undefined }, ...params }) {
        return await fetchService({ url: '/loadwbreport', method: 'POST', data, ...params })
    }



    static async saveReportJur({ data = { shop: undefined, reportId: undefined, file: undefined }, ...params }) {
        return await fetchService({ url: '/savereportjur', method: 'POST', data, ...params })
    }


    // static async reserveStocksForPostings({ data = { reportIds: undefined, postingNumbers: undefined, ignoreDiffPrices: undefined }, ...params }) {
    //     return await fetchService({ url: '/reservestocks45', method: 'POST', data, ...params })
    // }

    static async excelReport({ data = { reportIds: 'Array', customerType: undefined, tab: undefined, operation_1c: undefined, providerId: undefined, market: undefined, shop: undefined, isExpress: undefined, search: undefined, filters: undefined, period: undefined, type: undefined }, ...params }) {
        return await fetchService({ url: '/excelreport', method: 'POST', data, options: { download: true }, ...params })
    }

     static async excelEksmoArtsMap({ data = { file: undefined }, ...params }) {
        return await fetchService({ url: '/exceleksmoartsmap', method: 'POST', data, options: { download: true }, ...params })
    }


}